var _path, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,16h-1c-1.65,0-3,1.35-3,3v5.56C14.41,24.21,13.73,24,13,24c-2.21,0-4,1.79-4,4s1.79,4,4,4s4-1.79,4-4v-6h2  c1.65,0,3-1.35,3-3S20.65,16,19,16z M13,30c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S14.1,30,13,30z M19,20h-2v-1c0-0.55,0.45-1,1-1h1  c0.55,0,1,0.45,1,1S19.55,20,19,20z M16,10.28l-4.38,3.5c-0.43,0.35-1.06,0.28-1.41-0.16c-0.35-0.43-0.28-1.06,0.16-1.41l5-4  c0.37-0.29,0.88-0.29,1.25,0l5,4c0.43,0.34,0.5,0.97,0.16,1.41C21.58,13.87,21.29,14,21,14c-0.22,0-0.44-0.07-0.62-0.22L16,10.28z   M30.99,14.99c0,5.53-4.58,6.99-7,6.99c-0.55,0-1-0.45-1-1s0.45-1,1-1c0.51,0,5-0.18,5-4.99c0-1.41-0.36-2.5-1.1-3.34  c-1.43-1.63-3.88-1.66-3.91-1.66c-0.55,0-1-0.45-1-1C22.99,8.71,22.87,2,16,2C9.09,2,9.01,8.7,9.01,8.99c0,0.55-0.45,1-1,1  c-0.02,0-2.47,0.04-3.9,1.66c-0.74,0.84-1.1,1.93-1.1,3.34c0,4.81,4.49,4.99,5,4.99c0.06,0,0.13,0.01,0.19,0.02H12  c0.55,0,1,0.45,1,1s-0.45,1-1,1H8c-0.07,0-0.15-0.01-0.22-0.02c-2.47-0.09-6.77-1.63-6.77-6.99c0-1.9,0.54-3.47,1.6-4.66  c1.38-1.57,3.31-2.08,4.45-2.25C7.4,4.85,9.54,0,16,0c6.46,0,8.6,4.85,8.94,8.07c1.14,0.17,3.07,0.69,4.45,2.26  C30.45,11.52,30.99,13.09,30.99,14.99z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 47,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 52,
    fill: "#fff",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSong);
export default __webpack_public_path__ + "static/media/upload-song.0ec7242e8623965d16e77cafa16709f0.svg";
export { ForwardRef as ReactComponent };